<template>
  <div :class="{ 'center-screen' : !isMobile }">
    <div class="container">
      <div class="auth-page">
        <h1 v-if="!isMobile">{{ $store.getters['getClientMeta'].name }} Hoşgeldiniz</h1>
        <p v-if="!isMobile">Güvenilir ve Kazandıran casinonun adresi {{ $store.getters['getClientMeta'].name }}'e tekrardan hoşgeldiniz.</p>
        <div class="form">
          <div class="row">
            <div class="col col-4" v-if="!isMobile">
              <img v-if="!_.isEmpty(banner)" :src="$store.state.main.cdn_url + banner.image">
            </div>
            <div class="col col-8">
                <div class="content">
                  <h3 class="line-title">Giriş Yap</h3>
                  <form class="auth-content" v-on:submit.prevent="handleLogin">
                    <div class="col">
                        <div class="inline-form">
                          <label>Kullanıcı adınız</label>
                          <input type="text" v-model="form.username" placeholder="Kullanıcı adınızı yazınız">
                        </div>
                    </div>
                    <div class="col">
                        <div class="inline-form">
                          <label>Şifreniz</label>
                          <input type="password" v-model="form.password" placeholder="Şifrenizi yazınız">
                        </div>
                    </div>
                    <div class="col justify-flex-end">
                      <ButtonLoader class="primary" :loader="isLoading" :text="'Giriş Yapın'">
                        <template name="icon">
                          <svg x="0px" y="0px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve"><polygon points="437.3,30 202.7,339.3 64,200.7 0,264.7 213.3,478 512,94 "></polygon></svg>
                        </template>
                      </ButtonLoader>
                    </div>
                    <div class="col justify-flex-end">
                      <p>Giriş yaparken sorun mu yaşıyorsunuz ? <router-link to="/auth/forgot-password">Şifremi Unuttum</router-link></p>
                    </div>
                  </form>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapActions } from "vuex";
  export default{
    name: 'Login',
    data(){
      return{
        form:{
          username:null,
          password:null,
        },
        banner: null,
      }
    },
    mounted(){
      this.getBanner();
    },
    computed:{
      ...mapState("auth", ["isLoading"])
    },
    methods:{
      ...mapActions("auth", ["login"]),

      getBanner() {
          this.$store.dispatch('getBanner', ['login', 'both', 'left'])
          .then(response =>{
            this.banner   = !_.isUndefined(response.data['0']) ? response.data['0'] : [];
          });
      },
      handleLogin() {
        this.login(this.form)
      }
    },
  }
</script>